import React from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import { Box } from "@/components/Atoms";
import { useAppDispatch, useAppSelector } from "@/hooks";
import Typography from "@/foundation/Typography/V2";
import { setSelectedSearchValue, closeDropdown } from "@/redux/FaqsReducer";

function Dropdown() {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { dropdownList } = useAppSelector((state) => state.yogaFaqsReducer);

  const handleClickOnQuestion = (url: string, question: string) => {
    router.push(`/faqs/${url}`);
    dispatch(
      setSelectedSearchValue({
        text: question,
      })
    );
    dispatch(closeDropdown());
  };
  return (
    <Wrapper>
      {dropdownList?.length > 0 &&
        dropdownList.map(
          ({
            question,
            styledQuestion,
            url,
          }: {
            question: string;
            url: string;
            styledQuestion: string;
          }) => {
            return (
              <DropdownText
                variant="paragraph1"
                onClick={() => handleClickOnQuestion(url, question)}
                dangerouslySetInnerHTML={{
                  __html: styledQuestion,
                }}
              />
            );
          }
        )}

      {dropdownList?.length === 0 && (
        <EmptyListText variant="paragraph1">
          Sorry...No suggestions found
        </EmptyListText>
      )}
    </Wrapper>
  );
}

export default Dropdown;

const Wrapper = styled(Box)`
  position: absolute;
  top: 60px;
  display: flex;
  width: 600px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  height: 248px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
  overflow: auto;

  @media (max-width: 650px) {
    width: 100%;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const DropdownText = styled(Typography)`
  color: #344054;
  font-family: var(--man);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  span {
    color: #6e55d3;
    font-family: var(--man);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
`;

const EmptyListText = styled(Typography)`
  color: #344054;
  font-family: var(--man);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  opacity: 0.4;
  text-align: center;
  width: 100%;
`;
